/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { LoginData } from './interfaces/LoginData'

// Puedes eliminar estas líneas si no las usas:
// export const MCP_USER_LDAP_GROUP = 'cn=IT-MCP-User,ou=Groups,dc=autozone,dc=com'
// export const MCP_MAINTAINER_LDAP_GROUP = 'cn=IT-MCP-Maintainer,ou=Groups,dc=autozone,dc=com'
// export const MCP_APPROVER_LDAP_GROUP = 'cn=IT-MCP-Approver,ou=Groups,dc=autozone,dc=com'

export interface PkceValues {
  verifier: string
  challenge: string
}


export interface AuthStoreSettings {
  baseURL: string
  tokenURL: string
  revokeURL: string
  publicClientID: string
  redirectURI: string
  scope: string[]
  skipAuthorization?: boolean
  getUserData?: boolean
  disabledForDevelopment?: boolean
  mobileURL?: boolean
  pkceLoginURL?: string
}

export enum UserRole {
  USER = 'User',
  MAINTAINER = 'Maintainer',
  APPROVER = 'Approver',
}

export interface UserInformation {
  ignitionId: string
  mail: string
  givenName: string
  surName: string
  completeName: string
  roles: UserRole[]
  accessToken: string
}

export interface AuthStoreState {
  settings: AuthStoreSettings
  isAuthenticated: boolean
  authorizationData: any
  userData: any
  loginData: Nullable<LoginData>
  pkceValues: any
  user?: UserInformation
  tokenExpirationDate: string | null
  setTokenExpiresIn: (expiresIn: number | null) => void
  setTokenExpirationDate: (date: string | null) => void
  setPKCEValues: (pkceValues: any) => void
  setLoginData: (loginData: LoginData) => void
  handleTokenRefresh: (newLoginData: LoginData) => void
  setIsAuthenticated: (isAuthenticated: boolean) => void
  setAuthorizationData: (data: any) => void
  setUserData: (userData: any) => void
  clearAuthInfo: () => void
}
